// each custom query param for MFC APP
// some of these are for affiliate referrals / tracking purposes
export const QUERY_PARAM_SKIP_INITIAL_POPUP = 'skip_initial_popup'
export const QUERY_PARAM_DISPLAY_TYPE = 'display_type'
export const QUERY_PARAM_REDIRECT_FROM_WWW = 'redirect_from_www'
export const QUERY_PARAM_SIGNUP = 'signup'

// helpers
export const QUERY_PARAM_DEBUG = 'debug'
